<div *ngIf="sidebarActionBtn" (click)="sidebarActionBtn.action()">
  <button class="btn btn-block btn-success p-2 rounded-1 d-flex justify-content-center align-items-center">
    <i *ngIf="sidebarActionBtn.icon" class="icon icon-16 me-1" [ngClass]="sidebarActionBtn.icon"></i
    ><span>{{ sidebarActionBtn.title | translate }}</span>
  </button>
</div>
